export default __webpack_public_path__ + "static/media/smartphone.95b87baa.png";